import { render, staticRenderFns } from "./duo_custom_answer_input.vue?vue&type=template&id=5fa98772"
import script from "./duo_custom_answer_input.vue?vue&type=script&lang=js"
export * from "./duo_custom_answer_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports